// Link to a cert's PriceCharting page, opened at the sold listings for its grade.
// PriceCharting's columns map to PSA grades: used = 6 and below, cib = 7, new = 8,
// graded = 9, manual-only = 10. The /game/{id} link redirects and keeps the anchor.

const gradeAnchor = (grade) => {
    const numbers = String(grade || '').match(/\d+(\.\d+)?/g);
    if (!numbers) return '';
    const gradeNumber = parseFloat(numbers[numbers.length - 1]);
    if (gradeNumber >= 10) return '#completed-auctions-manual-only';
    if (gradeNumber >= 9) return '#completed-auctions-graded';
    if (gradeNumber >= 8) return '#completed-auctions-new';
    if (gradeNumber >= 7) return '#completed-auctions-cib';
    return '#completed-auctions-used';
};

export const priceChartingUrl = (cert) =>
    cert?.price_charting_id ? `https://www.pricecharting.com/game/${cert.price_charting_id}${gradeAnchor(cert.grade)}` : null;
